import {Alert, Autocomplete, Box, Button, Container, Fade, Grid, IconButton, MenuItem, Modal, Paper, Skeleton, Stack, styled, TextField, Tooltip, Typography} from "@mui/material";
import {Helmet} from "react-helmet";
import {AddCircleRounded, DeleteRounded, EditRounded} from "@mui/icons-material";
import LoginModal from "../../../components/common/loginModal";
import InputFieldModal from "../../../components/dashboard/drive/inputFieldModal";
import ConfirmDialog from "../../../components/common/confirmDialog";
import {FarsiDatePicker} from "../../../components/common/farsiDatePicker";
import {LoadingButton} from "../../../theme/components/LoadingButton";
import {useUser} from "../../../lib/hooks";
import {useEffect, useRef, useState} from "react";
import {addAddressBook, addAddressBookGroup, editAddressBook, editAddressBookGroup, getAllAddressBookGroups, getAllAddressBooks, removeAddressBook, removeAddressBookGroup} from "../../../lib/services/drive";
import Toasty from "../../../theme/components/Toasty";
import {validateEmail, validatePhoneNumber} from "../../../lib/commonFunctions/regexValidators";

export default function MyContacts() {

    const user = useUser();
    const [isLoggedIn, setIsLoggedIn] = useState(Boolean(user));

    const [groups, setGroups] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState('');
    const [contacts, setContacts] = useState([]);
    const [selectedContacts, setSelectedContacts] = useState([]);
    const [selectedContact, setSelectedContact] = useState(null);
    const [loading, setLoading] = useState(true);
    const [contactsLoading, setContactsLoading] = useState(true);
    const [pending, setPending] = useState(false);

    const [loginModalOpen, setLoginModalOpen] = useState(false);
    const [newGroupModalOpen, setNewGroupModalOpen] = useState(false);
    const [editGroupModalOpen, setEditGroupModalOpen] = useState(false);
    const [deleteGroupConfirm, setDeleteGroupConfirm] = useState(false);

    const [newContactModalOpen, setNewContactModalOpen] = useState(false);
    const [deleteContactConfirm, setDeleteContactConfirm] = useState(false);
    const [newContactData, setNewContactData] = useState({
        firstName: '',
        firstNameError: false,
        lastName: '',
        lastNameError: false,
        email: '',
        emailError: false,
        phoneNumber: '',
        phoneNumberError: false,
        birthDate: new Date(),
    });
    const [isEditingContact, setIsEditingContact] = useState(false);
    const [errors, setErrors] = useState([]);

    const clearGroupBtnRef = useRef(null);
    const clearContactsBtnRef = useRef(null);

    async function getGroupsData() {
        const {data} = await getAllAddressBookGroups();
        if (data?.isSuccess) {
            setGroups(data.value);
        } else {
            if (data && data.errors?.length) {
                data.errors.map(i => Toasty.error(i));
            }
        }
    }
    async function getContacts(){
        const {data} = await getAllAddressBooks();
        if (data?.isSuccess) {
            const allContacts = data.value;
            const newContacts = [];
            allContacts.forEach(i => {
                if (i.groupId === selectedGroup) {
                    const contact = {
                        id: i.id,
                        groupId: i.groupId,
                        firstName: i.firstName,
                        lastName: i.lastName,
                        email: i.emailAddress,
                        phoneNumber: i.mobileNumber,
                        birthDate: i.birthDay
                    };
                    newContacts.push(contact)
                }
            })
            setContacts(newContacts);
        } else {
            if (data && data.errors?.length) {
                data.errors.map(i => Toasty.error(i));
            }
        }
        setContactsLoading(false);
    }

    // Inputs
    const handleContactInputChange = (e) => {
        const {target: {name, value}} = e;
        setNewContactData({...newContactData, [name]: value});
    }

    // Groups
    const handleAddGroup = async (name) => {
        setPending(true);
        try {
            const {data} = await addAddressBookGroup(name);
            if (data?.isSuccess) {
                const payload = data.value;
                const newGroup = {
                    id: payload.abG_ID,
                    name: payload.abG_Name
                };
                setGroups([...groups, newGroup]);
                if (data.successMessage) Toasty.success(data.successMessage);
                setNewGroupModalOpen(false);
                setSelectedGroup(newGroup.id);
            } else {
                if (data && data.errors?.length) {
                    data.errors.map(i => Toasty.error(i));
                }
            }
            setPending(false);
        } catch (err) {
            Toasty.error('خطایی غیر منتظره رخ داد');
            setPending(false);
        }
    }
    const handleDeleteGroup = async (id) => {
        setPending(true);
        try {
            const {data} = await removeAddressBookGroup(id);
            if (data?.isSuccess) {
                clearGroupBtnRef.current?.click();
                setSelectedGroup('');
                setGroups(groups.filter(i => i.id !== id));
                if (data.successMessage) Toasty.success(data.successMessage);
                setDeleteGroupConfirm(false);
            } else {
                if (data && data.errors?.length) {
                    data.errors.map(i => Toasty.error(i));
                }
            }
            setPending(false);
        } catch (err) {
            console.log(err);
            Toasty.error('خطایی غیر منتظره رخ داد');
            setPending(false);
        }
    }
    const handleEditGroup = async (name) => {
        setPending(true);
        try {
            const {data} = await editAddressBookGroup(selectedGroup, name);
            if (data?.isSuccess) {
                const newGroups = [...groups];
                const index = groups.findIndex(i => i.id === selectedGroup);
                if (index >= 0) {
                    newGroups[index].name = name;
                    setGroups(newGroups);
                    if (data.successMessage) Toasty.success(data.successMessage);
                }
                setEditGroupModalOpen(false);
                setPending(false);
            } else {
                if (data && data.errors?.length) {
                    data.errors.map(i => Toasty.error(i));
                }
            }
        } catch (err) {
            Toasty.error('خطایی غیر منتظره رخ داد');
            setPending(false);
        }
    }

    // Contacts
    const handleOpenContactModal = (action, selected) => {
        switch (action) {
            case 'add':  {
                setIsEditingContact(false);
                setNewContactData({});
                return setNewContactModalOpen(true);
            }
            case 'edit': {
                setIsEditingContact(true);
                const selectedItem = contacts.find(i => i.id === selected)
                if (selectedItem) {
                    setNewContactData(
                        {
                            id: selectedItem.id,
                            groupId: selectedItem.groupId,
                            firstName: selectedItem.firstName,
                            lastName: selectedItem.lastName,
                            phoneNumber: selectedItem.phoneNumber,
                            birthDate: selectedItem.birthDate,
                            email: selectedItem.email,
                        });
                }
                return setNewContactModalOpen(true);
            }
            default: setNewContactModalOpen(true);
        }
    }
    const handleValidateNewContact = () => {
        let newErrors = [];
        const {firstName, lastName, email, phoneNumber} = newContactData;
        const newContact = {...newContactData}
        newContact.firstNameError = false;
        newContact.lastNameError = false;
        newContact.emailError = false;
        newContact.phoneNumberError = false;
        if (!firstName) {
            newContact.firstNameError = true
            newErrors.push('نام به درستی وارد نشده است');
        }
        if (!lastName) {
            newContact.lastNameError = true;
            newErrors.push('نام خانوادگی به درستی وارد نشده است');
        }
        if (email && !validateEmail(email)) {
            newContact.emailError = true;
            newErrors.push('ایمیل به درستی وارد نشده است')
        }
        if (phoneNumber && !validatePhoneNumber(phoneNumber)) {
            newContact.phoneNumberError = true;
            newErrors.push('شماره موبایل به درستی وارد نشده است')
        }
        setNewContactData(newContact);
        return newErrors;
    }
    const handleAddContact = async(e) => {
        e.preventDefault();
        if (!selectedGroup) return;
        setErrors([]);
        const errors = handleValidateNewContact();
        if (errors.length) return setErrors(errors);
        setPending(true);
        try {
            const payload = {
                groupId: selectedGroup,
                firstName: newContactData.firstName,
                lastName: newContactData.lastName,
                emailAddress: newContactData.email,
                mobileNumber: newContactData.phoneNumber,
                birthDay: newContactData.birthDate
            }
            const {data} = await addAddressBook(payload);
            if (data?.isSuccess) {
                const result = data.value;
                const newContact = {
                    id: result.abC_ID,
                    groupId: result.abC_GroupID,
                    firstName: result.abC_FirstName,
                    lastName: result.abC_LastName,
                    email: result.abC_EmailAddress,
                    phoneNumber: result.abC_MobileNumber,
                    birthDate: result.abC_Birthday,
                }
                setContacts([...contacts, newContact]);
                if (data.successMessage) Toasty.success(data.successMessage);
                setNewContactModalOpen(false);
            } else {
                if (data && data.errors?.length) {
                    data.errors.map(i => Toasty.error(i));
                }
            }
            setPending(false);
        } catch (err) {
            Toasty.error('خطایی غیر منتظره رخ داد')
            setPending(false);
        }
    }
    const handleEditContact = async(e) => {
        e.preventDefault();
        setErrors([]);
        const errors = handleValidateNewContact();
        if (errors.length) return setErrors(errors);
        setPending(true);
        try {
            const payload = {
                id: newContactData.id,
                groupId: selectedGroup,
                firstName: newContactData.firstName,
                lastName: newContactData.lastName,
                emailAddress: newContactData.email,
                mobileNumber: newContactData.phoneNumber,
                birthDay: newContactData.birthDate
            }
            const {data} = await editAddressBook(payload);
            if (data?.isSuccess) {
                const newContacts = [...contacts];
                const index = newContacts.findIndex(i => i.id === selectedContact);
                if (index >= 0) {
                    newContacts[index] = {...newContacts[index], ...newContactData}
                    setContacts(newContacts);
                }
                if (data.successMessage) Toasty.success(data.successMessage);
                setNewContactModalOpen(false);
            } else {
                if (data && data.errors?.length) {
                    data.errors.map(i => Toasty.error(i));
                }
            }
            setPending(false);
        } catch (err) {
            Toasty.error('خطایی غیر منتظره رخ داد')
            setPending(false);
        }
    }
    const handleDeleteContact = async() => {
        if (!selectedContact) return;
        setPending(true);
        try {
            const {data} = await removeAddressBook(selectedContact);
            if (data?.isSuccess) {
                clearContactsBtnRef?.current?.click();
                setSelectedContacts(selectedContacts.filter(i => i !== selectedContact));
                setContacts(contacts.filter(i => i.id !== selectedContact));
                if (data.successMessage) Toasty.success(data.successMessage);
                setDeleteContactConfirm(false);
            } else {
                if (data && data.errors?.length) {
                    data.errors.map(i => Toasty.error(i));
                }
            }
            setPending(false);
        } catch (err) {
            console.log(err);
            Toasty.error('خطایی غیر منتظره رخ داد');
            setPending(false);
        }
    }

    useEffect(() => {
        if (isLoggedIn) {
            getGroupsData()
                .then(() => getContacts()
                    .then(() => setLoading(false)));
        } else setLoginModalOpen(true);
    }, [isLoggedIn]);
    useEffect(() => {
        setContactsLoading(true);
        if (isLoggedIn) {
            getContacts();
        }
    }, [isLoggedIn, selectedGroup]);

    return (
        <>
            <Helmet>
                <title>دفترچه آدرس - درایو میلفا</title>
            </Helmet>
            <Container sx={{ mt: 3 }}>

                <Typography fontSize={{ xs: "1.1rem" }} fontWeight={600}>دفترچه آدرس میلفا</Typography>
                {!loading
                    ?
                    <Grid mt={2} container spacing={2}>
                        <Grid item xs={12} lg={4}>
                            <Autocomplete
                                onChange={(e, value) => setSelectedGroup(value?.id)}
                                options={groups}
                                slotProps={{ clearIndicator: {ref: clearGroupBtnRef} }}
                                noOptionsText={<Box>
                                    <MenuItem disabled>هیچ موردی پیدا نشد</MenuItem>
                                    <MenuItem onClick={() => setNewGroupModalOpen(true)}>افزودن گروه جدید</MenuItem>
                                </Box>}
                                loading={loading}
                                loadingText="در حال بارگذاری..."
                                getOptionLabel={(option) => option.name}
                                renderOption={(props, option, { selected }) => (
                                    <Box component="li" {...props}>
                                        <Box sx={{ width: 1, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                            <Typography>{option.name}</Typography>
                                            <Stack direction="row" alignItems="center" spacing={.25}>
                                                <Tooltip title="حذف">
                                                    <IconButton onClick={() =>  {setSelectedGroup(option.id); setDeleteGroupConfirm(true);}} color="error"><DeleteRounded fontSize="small"/></IconButton>
                                                </Tooltip>
                                                <Tooltip title="ویرایش">
                                                    <IconButton onClick={() =>  {setSelectedGroup(option.id); setEditGroupModalOpen(true);}} color="primary"><EditRounded fontSize="small"/></IconButton>
                                                </Tooltip>
                                            </Stack>
                                        </Box>
                                    </Box>
                                )}
                                renderInput={(params) => (
                                    <TextField {...params} label="انتخاب گروه" placeholder="لطفا گروه مورد نظر را انتخاب کنید" />
                                )}/>
                            <Box display="flex" alignItems='center' justifyContent="flex-end">
                                <Button onClick={() => setNewGroupModalOpen(true)} sx={{ mt: 1 }} startIcon={<AddCircleRounded/>}>افزودن گروه جدید</Button>
                            </Box>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                            <Autocomplete
                                onChange={(e, value) => setSelectedContacts(value)}
                                options={contacts}
                                slotProps={{ clearIndicator: {ref: clearContactsBtnRef} }}
                                noOptionsText='هیچ موردی پیدا نشد (از پر بودن فیلد گروه مطمئن شوید)'
                                loading={contactsLoading}
                                loadingText="در حال بارگذاری..."
                                getOptionLabel={(option) => option.email ? option.email : option.mobileNumber ? option.mobileNumber : option.firstName + " " + option.lastName}
                                renderOption={(props, option, { selected }) => (
                                    <Box component="li" {...props}>
                                        <Box sx={{ width: 1, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                            <Box display="flex" alignItems="center">
                                                {option.email ? option.email : option.mobileNumber ? option.mobileNumber : option.firstName + " " + option.lastName}
                                            </Box>
                                            <Stack direction="row" alignItems="center" spacing={.25}>
                                                <Tooltip title="حذف">
                                                    <IconButton onClick={(e) => {e.stopPropagation();setSelectedContact(option.id);setDeleteContactConfirm(true)}} color="error"><DeleteRounded fontSize="small"/></IconButton>
                                                </Tooltip>
                                                <Tooltip title="ویرایش">
                                                    <IconButton onClick={(e) => {e.stopPropagation();setSelectedContact(option.id);handleOpenContactModal('edit', option.id)}} color="primary"><EditRounded fontSize="small"/></IconButton>
                                                </Tooltip>
                                            </Stack>
                                        </Box>
                                    </Box>
                                )}
                                renderInput={(params) => (
                                    <TextField {...params} fullWidth label="انتخاب مخاطب" placeholder="لطفا مخاطب مورد نظر را انتخاب کنید" />
                                )}
                            />
                            <Box display="flex" alignItems='center' justifyContent="flex-end">
                                <Button disabled={!selectedGroup} onClick={() => handleOpenContactModal('add')} sx={{ mt: 1 }} startIcon={<AddCircleRounded/>}>افزودن مخاطب جدید</Button>
                            </Box>
                        </Grid>
                    </Grid>
                    :
                    <LoadingSkeleton/>
                }

                {/* Open Login Dialog if Not Logged In */}
                <LoginModal
                    open={loginModalOpen}
                    options={{ noReload: true, onSuccess: () => {setLoginModalOpen(false); setIsLoggedIn(true)} }}/>

                {/* Add Group */}
                <InputFieldModal
                    open={newGroupModalOpen}
                    onClose={() => setNewGroupModalOpen(false)}
                    inputProps={{ label: "نام گروه", placeholder: "لطفا نام گروه را وارد کنید" }}
                    pending={pending} onConfirm={handleAddGroup}/>

                {/* Edit Group */}
                <InputFieldModal
                    open={editGroupModalOpen}
                    onClose={() => setEditGroupModalOpen(false)}
                    inputProps={{ defaultValue: groups?.find(i => i.id === selectedGroup)?.name, label: "نام جدید", placeholder: "لطفا نام جدید گروه را وارد کنید" }}
                    pending={pending} onConfirm={handleEditGroup}/>

                {/* Delete Group */}
                <ConfirmDialog
                    open={deleteGroupConfirm}
                    onClose={() => setDeleteGroupConfirm(false)}
                    title="مطمئنی که میخوای پاکش کنی؟!"
                    description="اطلاعات پاک شده قابل بازیابی نیست"
                    color="error"
                    pending={pending}
                    onConfirm={() => handleDeleteGroup(selectedGroup)}/>

                {/* Add/Edit Contact */}
                <StyledModal open={newContactModalOpen} onClose={() => setNewContactModalOpen(false)}>
                    <Paper elevation={25} sx={{ width: {xs: "90%", lg: "auto" }, minWidth: { lg: "25%" }, maxWidth: {xs: "90%", lg: "35%", xl: "30%", xxl: "25%"}, maxHeight: "90%", minHeight: "50%", p: 2.5, borderRadius: 2.5, overflowY: "auto" }}>
                        <Typography fontSize={{ xs: "1.1rem", lg: "1.2rem" }} fontWeight={600} textAlign="center">مشخصات مخاطب</Typography>
                        <Grid mt={1} component="form" onSubmit={isEditingContact ? handleEditContact : handleAddContact} noValidate container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    value={newContactData.firstName} onChange={handleContactInputChange}
                                    error={!!newContactData.firstNameError}
                                    name="firstName" fullWidth required
                                    label='نام' placeholder="لطفا نام را وارد کنید"/>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    value={newContactData.lastName} onChange={handleContactInputChange}
                                    error={!!newContactData.lastNameError}
                                    name="lastName" fullWidth required
                                    label='نام خانوادگی' placeholder="لطفا نام خانوادگی را وارد کنید"/>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    value={newContactData.email} onChange={handleContactInputChange}
                                    error={!!newContactData.emailError}
                                    name="email" fullWidth required
                                    label='ایمیل' placeholder="لطفا ایمیل را وارد کنید"/>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    value={newContactData.phoneNumber} onChange={handleContactInputChange}
                                    error={!!newContactData.phoneNumberError}
                                    name="phoneNumber" fullWidth
                                    label='شماره موبایل' placeholder="لطفا شماره را وارد کنید"/>
                            </Grid>
                            <Grid item xs={12}>
                                <FarsiDatePicker
                                    value={newContactData.birthDate} onChange={(newDate) => setNewContactData({...newContactData, birthDate: newDate})}
                                    disableFuture sx={{ width: 1 }}/>
                            </Grid>
                            <Grid item xs={12}>
                                <LoadingButton
                                    loading={pending} type="submit" fullWidth
                                    variant="contained" disableElevation sx={{py: 1.5}}>ثبت</LoadingButton>
                            </Grid>
                        </Grid>
                        <Fade in={Boolean(errors.length)} unmountOnExit>
                            <Stack mt={3} spacing={1.5}>
                                {errors.map((err, ind) => (
                                    <Alert key={ind} severity="error">{err}</Alert>
                                ))}
                            </Stack>
                        </Fade>
                    </Paper>
                </StyledModal>

                {/* Delete Contact */}
                <ConfirmDialog
                    open={deleteContactConfirm}
                    onClose={() => setDeleteContactConfirm(false)}
                    title="مطمئنی که میخوای پاکش کنی؟!"
                    description="اطلاعات پاک شده قابل بازیابی نیست"
                    color="error"
                    pending={pending}
                    onConfirm={handleDeleteContact}/>
            </Container>
        </>
    )
}

const StyledModal = styled(Modal)(({theme}) => ({
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
}));
const LoadingSkeleton = () => {
    return (
        <Grid mt={2} container spacing={2}>
            <Grid item xs={12} lg={4}>
                <Skeleton variant="rounded" height="3.5rem"/>
            </Grid>
            <Grid item xs={12} lg={4}>
                <Skeleton variant="rounded" height="3.5rem"/>
            </Grid>
        </Grid>
    )
}
